function userDataReducer(state = {
  final_code_url:null,
  range_date:7,
  token: null,
  user_id: null,
  fio: '',
  phone: '',
  inn: '',
  email: null,
  referer: 'pg',
  doc_number: '',
  city: '',
  birth_date: '',
  doc_date: '',
  amount: 3000,
  days: null,
  code: null,
  last_name: '',
  second_name: '',
}, action) {
  switch (action.type) {
    case 'ADD_TOKEN':
      return {
        ...state,
        token: action.token
      };
      case 'ADD_USER_ID':
      return {
        ...state,
        user_id: action.user_id
      };
    case 'ADD_FIO':
      return {
        ...state,
        fio: action.fio
      };
    case 'ADD_PHONE':
      return {
        ...state,
        phone: action.phone
      };
    case 'ADD_INN':
      return {
        ...state,
        inn: action.inn
      };
    case 'ADD_LAST_NAME':
      return {
        ...state,
        last_name: action.last_name
      };
    case 'ADD_FIRST_NAME':
      return {
        ...state,
        first_name: action.first_name
      };
    case 'ADD_SECOND_NAME':
      return {
        ...state,
        second_name: action.second_name
      };
    case 'ADD_EMAIL':
      return {
        ...state,
        email: action.email
      };
    case 'ADD_REFERER':
      return {
        ...state,
        referer: action.referer
      };
    case 'ADD_DOC_NUMBER':
      return {
        ...state,
        doc_number: action.doc_number
      };
    case 'ADD_DOC_CITY':
      return {
        ...state,
        city: action.city
      };
    case 'ADD_BIRTH_DATE':
      return {
        ...state,
        birth_date: action.birth_date
      };
    case 'ADD_DOC_DATE':
      return {
        ...state,
        doc_date: action.doc_date
      };
    case 'ADD_AMOUNT':
      return {
        ...state,
        amount: action.amount
      };
    case 'ADD_DAYS':
      return {
        ...state,
        days: action.days
      };
    case 'ADD_CODE':
      return {
        ...state,
        code: action.code
      };
      case 'ADD_FINAL_CODE_URL':
      return {
        ...state,
        final_code_url: action.final_code_url
      };
    default:
      return state;
  }
}


export default userDataReducer





// WEBPACK FOOTER //
// src/reducers/userDataReducer.js